var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:_vm.classes},'button',_vm.$attrs,false),_vm.eventListeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }